/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const InviteOrganizationMemberBody = zod
	.object({
		email: zod.email().describe('Invitee email address'),
		full_name: zod.string().nullable().describe('Invitee full name'),
		role: zod.enum(['owner', 'member'])
	})
	.describe('Invite a user to the organization');

export type InviteOrganizationMemberBody = zod.input<typeof InviteOrganizationMemberBody>;
export type InviteOrganizationMemberBodyOutput = zod.output<typeof InviteOrganizationMemberBody>;
